import { forwardRef, type TextareaHTMLAttributes } from 'react'

export interface FormTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string | boolean
  sizeVariant?: 'sm' | 'md' | 'lg'
  size?: 'sm' | 'md' | 'lg'
  resizable?: boolean
}

export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  (
    {
      error,
      sizeVariant = 'md',
      size,
      resizable = false,
      className = '',
      disabled,
      rows = 3,
      ...props
    },
    ref
  ) => {
    const hasError = Boolean(error)
    const effectiveSize = (typeof size === 'string' ? size : sizeVariant) as 'sm' | 'md' | 'lg'

    const sizeClasses = {
      sm: 'text-[13px] px-3 py-2',
      md: 'text-[14px] px-3.5 py-2.5',
      lg: 'text-[14px] px-4 py-3',
    }[effectiveSize] || 'text-[14px] px-3.5 py-2.5'

    const resizeClass = resizable ? '' : 'resize-none'

    const stateClasses = hasError
      ? 'border-[#d92d20] bg-[#fffbfa] text-[#101828] focus:border-[#d92d20] focus:ring-4 focus:ring-[#d92d20]/10'
      : 'border-[#cfdcdf] bg-white text-[#101828] hover:border-[#98a2b3] focus:border-[#0b6166] focus:ring-4 focus:ring-[#0b6166]/10'

    return (
      <textarea
        ref={ref}
        rows={rows}
        disabled={disabled}
        className={`w-full rounded-[8px] border outline-none transition-colors duration-150 ease-in-out placeholder:text-[#98a2b3] placeholder:text-[13px] disabled:cursor-not-allowed disabled:bg-[#f9fafb] disabled:text-[#667085] disabled:border-[#e4e7ec] ${resizeClass} ${sizeClasses} ${stateClasses} ${className}`}
        {...props}
      />
    )
  }
)

FormTextarea.displayName = 'FormTextarea'


